module.exports = __webpack_public_path__ + "img/edit-linear-24x24.8b2966e9.svg";